<template>
  <form class="form form-loyalty-signup-start mb-0" @submit.prevent="postStart">
    <slide-x-left-transition :duration="400" :delay="300">
      <div class="form-group" v-show="show">
        <label>Wybierz aktywację:</label>
        <div class="select-wrapper">
          <span v-if="activation === null" class="select-placeholder">Wybierz aktywację</span>
          <select v-model="activation">
            <option v-for="item in activations" :value="item.slug">{{ item.title }}</option>
          </select>
        </div>
        <p class="error"
           v-if="errors['activation']"
           v-text="errors['activation'][0]">
        </p>
      </div>
    </slide-x-left-transition>
    <slide-y-up-transition :duration="500" :delay="400">
      <div v-if="show">
        <ion-button mode="ios"
                    size="small"
                    @click="postStart"
                    :disabled="activation === null"
                    class="mt-10">Przejdź dalej
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'FormLoyaltySignupActivationStart',
    computed: {
      ...mapGetters('profile', ['getProfile']),
      ...mapState({
        loading: state => state.loyalty.loading,
        errors: state => state.loyalty.errors,
        activations: state => state.loyalty.activations,
      }),
      ...mapFields({
        activation: 'signupActivationForm.activation',
      }),
    },
    data() {
      return {
        show: false
      }
    },
    mounted(){
      this.getActivations()
      this.getCompanyData()
    },
    methods: {
      getActivations(){
        let payload = {'sfa': this.$route.params.slug}
        this.$store.dispatch('loyalty/LOYALTY_ACTIVATIONS_REQUEST', payload).then(resp => {
          this.show = true
        })
      },
      getCompanyData(){
        let payload = {'ph_slug': this.getProfile.slug, 'sfa': this.$route.params.slug};
        this.$store.dispatch('clients/PH_PLACES_DETAILS_REQUEST', payload).then(resp => {
          // bind "company_data" to signup activation form
          this.$store.commit('loyalty/LOYALTY_SET_SIGNUP_ACTIVATION_COMPANY_DATA', resp.data.data)
          // set contractor profile
          this.$store.commit('loyalty/LOYALTY_SET_CONTRACTOR_PROFILE', resp.data.data.userSigningContract)
          // set sales profile
          this.$store.commit('loyalty/LOYALTY_SET_SALES_PROFILE', this.getProfile)
        })
      },
      postStart(){
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_ACTIVATION_STORE_REQUEST', 1)
      }
    }
  }
</script>